export default __webpack_public_path__ + "images/15_1_image.jpg";